/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSavingsTransferRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetSavingsTransferResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getSavingsTransfer = (request: GetSavingsTransferRequest, options?: CashRequestOptions) => post<GetSavingsTransferRequest, GetSavingsTransferResponse>("/2.0/cash/get-savings-transfer", request, {...options, rejectOnError: true })